'use strict';

exports.__esModule = true;
var PREFIX = exports.PREFIX = 'react-redux-fetch/';

var FETCH = exports.FETCH = {
  for: function _for(verb) {
    return {
      REQUEST: '' + PREFIX + verb.toUpperCase() + '_REQUEST',
      FULFILL: '' + PREFIX + verb.toUpperCase() + '_FULFIL',
      REJECT: '' + PREFIX + verb.toUpperCase() + '_REJECT'
    };
  }
};

var CLEAR = exports.CLEAR = PREFIX + 'CLEAR';


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-redux-fetch/lib/constants/actionTypes.js
// module id = 55
// module chunks = 0